// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 56px;
}

.machine-group-manager {
  display: flex;
  height: 100vh;
  background: #f5f5f5;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 14px;
}

/* 좌측 패널 */
.left-panel {
  width: 300px;
  background: white;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #fafafa;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--header-height);
}

.panel-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.2em;
}

.header-buttons {
  display: flex;
  gap: 10px;
}

.header-buttons button {
  padding: 10px 20px;
  border: 2px solid #007bff;
  border-radius: 6px;
  background: #007bff;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0,123,255,0.2);
}

.header-buttons button:hover:not(:disabled) {
  background: #0056b3;
  border-color: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,123,255,0.3);
}

.header-buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #6c757d;
  border-color: #6c757d;
  transform: none;
  box-shadow: none;
}

.machine-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}

.machine-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  margin-bottom: 5px;
  border-radius: 6px;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.machine-item:hover {
  background: #f8f9fa;
  border-color: #e9ecef;
}

.machine-item.selected {
  background: #e3f2fd;
  border-color: #2196f3;
  color: #1976d2;
}

.machine-info {
  display: flex;
  align-items: center;
  flex: 1 1;
  cursor: pointer;
}

.status-toggle-btn {
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 8px;
  transition: all 0.2s;
  min-width: 60px;
  font-weight: 500;
}

.status-toggle-btn.active {
  background: #27ae60;
  color: white;
  border: 1px solid #229954;
}

.status-toggle-btn.active:hover {
  background: #229954;
  border-color: #1e8449;
}

.status-toggle-btn.inactive {
  background: #e74c3c;
  color: white;
  border: 1px solid #c0392b;
}

.status-toggle-btn.inactive:hover {
  background: #c0392b;
  border-color: #a93226;
}

.machine-icon {
  margin-right: 10px;
  font-size: 16px;
}

.machine-name {
  font-weight: 500;
}

/* 우측 패널 */
.right-panel {
  flex: 1 1;
  background: white;
  display: flex;
  flex-direction: column;
}

.group-editor {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}



.sensor-grid {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  overflow-y: auto;
}

.grid-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
  color: #555;
  grid-template-rows: var(--header-height);
}

.grid-header > div {
  padding: 12px 15px;
  border-right: 1px solid #ddd;
}

.grid-header > div:last-child {
  border-right: none;
}

.grid-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  border-bottom: 1px solid #eee;
  align-items: center;
}

.grid-row:last-child {
  border-bottom: none;
}

.grid-row > div {
  padding: 12px 15px;
  border-right: 1px solid #eee;
}

.grid-row > div:last-child {
  border-right: none;
}

.group-row {
  background: #fafafa;
  font-weight: 500;
}

.group-row.ungrouped {
  background: #f0f0f0;
  color: #666;
}

.ungrouped-label {
  font-style: italic;
  color: #888;
}

/* 드래그 앤 드롭 스타일 */
.draggable {
  cursor: move;
  transition: all 0.2s ease;
}

.draggable:hover {
  background: #f0f8ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.draggable:active {
  opacity: 0.7;
}

.drag-handle {
  margin-right: 8px;
  color: #999;
  font-size: 12px;
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}

.drop-zone {
  transition: all 0.2s ease;
}

.drop-zone:hover {
  background: #e8f5e8;
  border-left: 3px solid #4caf50;
}

.drop-zone.drag-over {
  background: #e8f5e8;
  border-left: 3px solid #4caf50;
  box-shadow: inset 0 0 10px rgba(76, 175, 80, 0.2);
}

.sensor-row {
  background: white;
}

.sensor-row.grouped {
  background: #f9f9f9;
}

.col-name {
  display: flex;
  align-items: center;
}

.group-icon, .sensor-icon {
  margin-right: 8px;
  font-size: 14px;
}

.indent {
  margin-right: 8px;
  color: #999;
}

.group-name-input {
  border: 1px solid #ddd;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  max-width: 200px;
}

.value-input {
  border: 1px solid #ddd;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 14px;
  width: 80px;
  text-align: center;
}

.value-input.readonly {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
  border-color: #ccc;
}

.setting-value-display {
  display: inline-block;
  padding: 6px 8px;
  background-color: #e8f4fd;
  color: #1976d2;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  min-width: 60px;
  text-align: center;
}



.inline-remove-btn {
  background: #f44336;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
  transition: background 0.2s;
}

.inline-remove-btn:hover {
  background: #d32f2f;
}



.no-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-size: 1.1em;
}

/* 반응형 */
@media (max-width: 768px) {
  .machine-group-manager {
    flex-direction: column;
  }
  
  .left-panel {
    width: 100%;
    height: 200px;
  }
  
  .machine-list {
    display: flex;
    overflow-x: auto;
    padding: 10px;
  }
  
  .machine-item {
    min-width: 150px;
    margin-right: 10px;
    margin-bottom: 0;
  }
  
  .grid-header,
  .grid-row {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  
  .grid-header > div,
  .grid-row > div {
    border-right: none;
    border-bottom: 1px solid #eee;
    padding: 6px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MachineGroupManager.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;;;AAIA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;;;AAIA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;IAEE,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;EACnB;AACF","sourcesContent":[":root {\r\n  --header-height: 56px;\r\n}\r\n\r\n.machine-group-manager {\r\n  display: flex;\r\n  height: 100vh;\r\n  background: #f5f5f5;\r\n  font-family: 'Segoe UI', Arial, sans-serif;\r\n  font-size: 14px;\r\n}\r\n\r\n/* 좌측 패널 */\r\n.left-panel {\r\n  width: 300px;\r\n  background: white;\r\n  border-right: 1px solid #ddd;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.panel-header {\r\n  padding: 20px;\r\n  border-bottom: 1px solid #eee;\r\n  background: #fafafa;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  height: var(--header-height);\r\n}\r\n\r\n.panel-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.header-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.header-buttons button {\r\n  padding: 10px 20px;\r\n  border: 2px solid #007bff;\r\n  border-radius: 6px;\r\n  background: #007bff;\r\n  color: white;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: all 0.2s;\r\n  box-shadow: 0 2px 4px rgba(0,123,255,0.2);\r\n}\r\n\r\n.header-buttons button:hover:not(:disabled) {\r\n  background: #0056b3;\r\n  border-color: #0056b3;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 8px rgba(0,123,255,0.3);\r\n}\r\n\r\n.header-buttons button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  background: #6c757d;\r\n  border-color: #6c757d;\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.machine-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 10px;\r\n}\r\n\r\n.machine-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 6px 10px;\r\n  margin-bottom: 5px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.machine-item:hover {\r\n  background: #f8f9fa;\r\n  border-color: #e9ecef;\r\n}\r\n\r\n.machine-item.selected {\r\n  background: #e3f2fd;\r\n  border-color: #2196f3;\r\n  color: #1976d2;\r\n}\r\n\r\n.machine-info {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.status-toggle-btn {\r\n  padding: 6px 12px;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  margin-left: 8px;\r\n  transition: all 0.2s;\r\n  min-width: 60px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-toggle-btn.active {\r\n  background: #27ae60;\r\n  color: white;\r\n  border: 1px solid #229954;\r\n}\r\n\r\n.status-toggle-btn.active:hover {\r\n  background: #229954;\r\n  border-color: #1e8449;\r\n}\r\n\r\n.status-toggle-btn.inactive {\r\n  background: #e74c3c;\r\n  color: white;\r\n  border: 1px solid #c0392b;\r\n}\r\n\r\n.status-toggle-btn.inactive:hover {\r\n  background: #c0392b;\r\n  border-color: #a93226;\r\n}\r\n\r\n.machine-icon {\r\n  margin-right: 10px;\r\n  font-size: 16px;\r\n}\r\n\r\n.machine-name {\r\n  font-weight: 500;\r\n}\r\n\r\n/* 우측 패널 */\r\n.right-panel {\r\n  flex: 1;\r\n  background: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.group-editor {\r\n  flex: 1;\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n}\r\n\r\n\r\n\r\n.sensor-grid {\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.grid-header {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr 1fr;\r\n  background: #f5f5f5;\r\n  border-bottom: 1px solid #ddd;\r\n  font-weight: 600;\r\n  color: #555;\r\n  grid-template-rows: var(--header-height);\r\n}\r\n\r\n.grid-header > div {\r\n  padding: 12px 15px;\r\n  border-right: 1px solid #ddd;\r\n}\r\n\r\n.grid-header > div:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.grid-row {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr 1fr;\r\n  border-bottom: 1px solid #eee;\r\n  align-items: center;\r\n}\r\n\r\n.grid-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.grid-row > div {\r\n  padding: 12px 15px;\r\n  border-right: 1px solid #eee;\r\n}\r\n\r\n.grid-row > div:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.group-row {\r\n  background: #fafafa;\r\n  font-weight: 500;\r\n}\r\n\r\n.group-row.ungrouped {\r\n  background: #f0f0f0;\r\n  color: #666;\r\n}\r\n\r\n.ungrouped-label {\r\n  font-style: italic;\r\n  color: #888;\r\n}\r\n\r\n/* 드래그 앤 드롭 스타일 */\r\n.draggable {\r\n  cursor: move;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.draggable:hover {\r\n  background: #f0f8ff;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.draggable:active {\r\n  opacity: 0.7;\r\n}\r\n\r\n.drag-handle {\r\n  margin-right: 8px;\r\n  color: #999;\r\n  font-size: 12px;\r\n  cursor: grab;\r\n}\r\n\r\n.drag-handle:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.drop-zone {\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.drop-zone:hover {\r\n  background: #e8f5e8;\r\n  border-left: 3px solid #4caf50;\r\n}\r\n\r\n.drop-zone.drag-over {\r\n  background: #e8f5e8;\r\n  border-left: 3px solid #4caf50;\r\n  box-shadow: inset 0 0 10px rgba(76, 175, 80, 0.2);\r\n}\r\n\r\n.sensor-row {\r\n  background: white;\r\n}\r\n\r\n.sensor-row.grouped {\r\n  background: #f9f9f9;\r\n}\r\n\r\n.col-name {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.group-icon, .sensor-icon {\r\n  margin-right: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.indent {\r\n  margin-right: 8px;\r\n  color: #999;\r\n}\r\n\r\n.group-name-input {\r\n  border: 1px solid #ddd;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  width: 100%;\r\n  max-width: 200px;\r\n}\r\n\r\n.value-input {\r\n  border: 1px solid #ddd;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  width: 80px;\r\n  text-align: center;\r\n}\r\n\r\n.value-input.readonly {\r\n  background-color: #f5f5f5;\r\n  color: #666;\r\n  cursor: not-allowed;\r\n  border-color: #ccc;\r\n}\r\n\r\n.setting-value-display {\r\n  display: inline-block;\r\n  padding: 6px 8px;\r\n  background-color: #e8f4fd;\r\n  color: #1976d2;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  min-width: 60px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n\r\n.inline-remove-btn {\r\n  background: #f44336;\r\n  color: white;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  margin-left: 10px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.inline-remove-btn:hover {\r\n  background: #d32f2f;\r\n}\r\n\r\n\r\n\r\n.no-selection {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  color: #999;\r\n  font-size: 1.1em;\r\n}\r\n\r\n/* 반응형 */\r\n@media (max-width: 768px) {\r\n  .machine-group-manager {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .left-panel {\r\n    width: 100%;\r\n    height: 200px;\r\n  }\r\n  \r\n  .machine-list {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .machine-item {\r\n    min-width: 150px;\r\n    margin-right: 10px;\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  .grid-header,\r\n  .grid-row {\r\n    grid-template-columns: 1fr;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .grid-header > div,\r\n  .grid-row > div {\r\n    border-right: none;\r\n    border-bottom: 1px solid #eee;\r\n    padding: 6px 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
